interface cookiesManagerES {
  cookies_manager: string;
  cookies_manager_desc: string;
  cookies_first: string;
  cookies_button_accept: string;
  cookies_button_reject: string;
  cookies_clear_all: string;
  cookies_information: string;
}

export const cookiesManagerES: cookiesManagerES = {
  cookies_manager: "GESTIONAR COOKIES",
  cookies_manager_desc:
    "Esta página le permite gestionar sus preferencias de cookies y controlar la información que recopilamos a través de cookies en nuestro sitio web. Ajustar estas configuraciones nos ayudará a ofrecer una experiencia mejor y más personalizada, respetando sus elecciones de privacidad.",
  cookies_first: "Cookies de YouTube",
  cookies_button_accept: "Aceptar cookies",
  cookies_button_reject: "Rechazar cookies",
  cookies_clear_all: "Eliminar todas las cookies",
  cookies_information:
    "Para más información sobre el uso de cookies, por favor revisa nuestra Política de Cookies.",
};
